import { TextInput, Tile } from '@Components/common';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styles from './ContactDetails.module.scss';
import { AddressSection } from '@Components';

export const ContactDetails = () => {
  const { t } = useTranslation('account');
  const { register, errors } = useFormContext();

  return (
    <Tile
      title={{
        title: t('tabs.organization.registered_details.contact_title'),
      }}
      className={styles.container}
    >
      <div>
        <TextInput
          inputRef={register}
          name="phone_number"
          label={t('tabs.organization.registered_details.phone_number')}
          placeholder="+441234567890"
          error={!!errors.phone_number}
          helperText={
            !errors.phone_number
              ? t('createAccount:create_profile_common.phone_number_hint')
              : errors.phone_number?.message
          }
        />

        <AddressSection
          isLoading={false}
          header={t('tabs.organization.registered_details.registered_address')}
          required={false}
        />
      </div>
    </Tile>
  );
};
